import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './FullProduct.css';

// --- BULK IMPORTS ---
import img1 from "../../../assets/Product/img1.png";
import img2 from "../../../assets/Product/img2.png";
import img3 from "../../../assets/Product/img3.png";
import img4 from "../../../assets/Product/img4.png";
import img5 from "../../../assets/Product/img5.png";
import img6 from "../../../assets/Product/img6.png";
import img7 from "../../../assets/Product/img7.png";
import img8 from "../../../assets/Product/img8.png";
import img9 from "../../../assets/Product/img9.png";
import img10 from "../../../assets/Product/img10.png";
import img11 from "../../../assets/Product/img11.png";
import img12 from "../../../assets/Product/img12.png";
import img13 from "../../../assets/Product/img13.png";
import img14 from "../../../assets/Product/img14.png";
import img15 from "../../../assets/Product/img15.png";
import img16 from "../../../assets/Product/img16.png";
import img17 from "../../../assets/Product/img17.png";
import img18 from "../../../assets/Product/img18.png";
import img19 from "../../../assets/Product/img19.png";
import img20 from "../../../assets/Product/img20.png";
import img21 from "../../../assets/Product/img21.png";
import img22 from "../../../assets/Product/img22.png";
import img23 from "../../../assets/Product/img23.png";
import img24 from "../../../assets/Product/img24.png";


import { Modal, Button } from 'react-bootstrap';

import AOS from 'aos';
import 'aos/dist/aos.css';

const FullProduct = () => {
  // Removed pagination state
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 12;

  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // 24 Products Array
  const allProducts = [
    { img: img1, title: "XBA LEVER ARM", desc: "Precision-stamped lever arm designed for controlled motion in automotive mechanisms." },
    { img: img2, title: "Sullo Brkt Fr", desc: "High-strength front bracket engineered for reliable mounting support in vehicle assemblies." },
    { img: img3, title: "BRKT-SLIDE MOTOR", desc: "Precision bracket for slide motor mounting, ensuring alignment, stability, and smooth operation." },
    { img: img4, title: "MTG BRKT E4RNSS", desc: "Mounting bracket developed for secure routing and support of automotive electrical harness systems." },
    { img: img5, title: "Front Pivot", desc: "Stamped front pivot component designed to enable smooth movement in automotive assemblies." },
    { img: img6, title: "PY1B Base", desc: "Robust base component manufactured for stable mounting and distribution in automotive systems." },
    { img: img7, title: "Cushion Side Member 60P", desc: "Structural side member designed to enhance strength in automotive seating or body systems." },
    { img: img8, title: "Back Side Member RH", desc: "Right-hand side structural member engineered for  dimensional accuracy in vehicle assemblies." },
    { img: img9, title: "Backing Plate", desc: "Precision backing plate manufactured to provide reinforcement mechanical assemblies." },
    { img: img10, title: "Fan Disk", desc: "High-accuracy stamped fan disk designed for balanced rotation and efficient airflow applications." },
    { img: img11, title: "IZUZU BRACKET", desc: "Custom automotive bracket developed to meet OEM specifications for mounting structural support." },
    { img: img12, title: "DOST BASE PLate ", desc: "Stamped base plate engineered for durability, alignment, secure integration , automotive systems." },
    { img: img13, title: "Console MTG BRKT", desc: "Precision-stamped mounting bracket designed for secure console assembly in automotive interiors." },
    { img: img14, title: "DIP STICK", desc: "High-accuracy dip stick component manufactured for reliable fluid level measurement in engines." },
    { img: img15, title: "Cushoion MEMBER", desc: "Stamped structural member engineered to support cushioning systems and vibration control." },
    { img: img16, title: "BAFFEL PLATE", desc: "Durable stamped plate designed to control fluid flow, noise, or heat within automotive systems." },
    { img: img17, title: "HINGH ASSY", desc: "Precision hinge assembly ensuring smooth movement durability in automotive applications." },
    { img: img18, title: "Cushoion PLATE", desc: "Formed metal plate used in cushioning assemblies to enhance strength and load distribution." },
    { img: img19, title: "HDT HORNE UNIT", desc: "Stamped and assembled horn mounting unit designed for secure vibration resistance." },
    { img: img20, title: "HORNE PLATE", desc: "High-strength stamped plate supporting horn assemblies in automotive electrical systems." },
    { img: img21, title: "DOST LEVER ARM", desc: "Dost lever arm component designed for controlled motion and mechanical reliability." },
    { img: img22, title: "PHONix  LEVER ARM", desc: "Precision-engineered lever arm manufactured for consistent performance in automotive mechanisms." },
    { img: img23, title: "BSA LEVER  ARM", desc: "Precision-engineered lever arm manufactured for consistent performance in automotive mechanisms." },
    { img: img24, title: "PSA BASE PLATE", desc: "Base plate component manufactured to provide stable mounting and support in assemblies." }
  ];

  const handleShow = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  return (
    <section className="full-product-section">
      <Container>
        {/* HEADER */}
        <Row className="mb-5 align-items-end">
          <Col lg={6} md={12}>
            <span className="fp-label">Our Products</span>
            <h1 className="fp-heading">
              Automotive <strong>Stamped<br />Components</strong>
            </h1>
          </Col>
          <Col lg={6} md={12}>
            <p className="fp-desc ms-lg-auto">
              We manufacture a comprehensive range of precision stamped components
              designed to meet stringent automotive OEM requirements.
            </p>
          </Col>
        </Row>

        {/* PRODUCT GRID - SHOW ALL PRODUCTS */}
        <Row className="product-grid-container gy-4">
          {allProducts.map((item, index) => (
            <Col
              lg={4} md={6} sm={12}
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100} // Incremental delay for "one by one" effect
            >
              <div
                className="fp-card"
                onClick={() => handleShow(item)}
                style={{ cursor: 'pointer' }}
              >
                <div className="fp-img-wrapper">
                  <img src={item.img} alt={item.title} className="fp-img" loading="lazy" />
                </div>
                <div className="fp-content">
                  <h3 className="fp-title">{item.title}</h3>
                  <p className="fp-text">{item.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* PAGINATION REMOVED */}

      </Container>

      {/* PRODUCT MODAL */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{selectedProduct?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {selectedProduct && (
            <>
              <img
                src={selectedProduct.img}
                alt={selectedProduct.title}
                className="img-fluid rounded mb-3"
                style={{ maxHeight: '400px', objectFit: 'contain' }}
              />
              <p className="lead text-muted">{selectedProduct.desc}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </section>
  );
};

export default FullProduct;